import {useDeleteUserById, useFindUsers} from "hooks/query/user-query"
import dayjs from "dayjs"
import {Outlet, useNavigate} from "react-router-dom"
import {NotificationType, showNotification} from "common/Notification"

export const UserListView = () => {
    const navigate = useNavigate()
    const {data: list} = useFindUsers()
    const deleteMutate = useDeleteUserById()
    // const [showRegisterWindow, setShowRegisterWindow] = useState<boolean>(false)
    console.log("user list : ", list)
    const deleteUser = (id?: string) => {
        if (!id) return
        if (!window.confirm("삭제하시겠습니까?")) return
        deleteMutate.mutate(id, {
            onSuccess: () => showNotification("삭제하였습니다", NotificationType.SUCCESS),
            onError: () => showNotification("삭제 하지 못했습니다")
        })
    }

    const goToUpdate = (id?: string) => {
        if (!id) return
        navigate(`/user/update/${id}/form`)
    }
    return (
        <div className="main-body">
            <div className="level mb0">
                <div className="level-left">
                    <h5 className="is-size-5 has-text-weight-bold ml5">Users</h5>
                </div>
                <div className="level-right">
                    <div className="level-item input-search-box3 mt5">
                        <div className="btn-search">
                            <i className="fa fa-search"/>
                        </div>
                        <input className="input" type="text" placeholder="검색"/>
                    </div>
                </div>
            </div>

            <div className="main-panel">
                <div className="level">
                    <div className="level-left">
                        <div className="level-item ml20 mt10 is-size-85">총 : {(list?.length || 0).toLocaleString()}명
                        </div>
                    </div>
                    <div className="level-right">
                        <a className="button is-purple2 is-size-85" onClick={() => navigate("register")}>
                            <span className="icon is-small">
                                <i className="fas fa-plus"/>
                            </span>
                            <span>User 추가</span>
                        </a>
                    </div>

                </div>

                <div className="grid-table grid-7 mt5">
                    <header className="header">
                        <div className="item">NO</div>
                        <div className="item">ID</div>
                        <div className="item">User Name</div>
                        <div className="item">Email</div>
                        <div className="item">Name</div>
                        <div className="item">Join Date</div>
                        <div className="item ">note</div>
                    </header>
                    {list && list.map(user => {
                        const {id, username, email, createdTimestamp, firstName, lastName} = user
                        const createdAt = createdTimestamp ? dayjs.unix(createdTimestamp / 1000).format("YYYY/MM/DD HH:mm:ss") : "-"
                        const name = firstName || "" + lastName || ""
                        return (
                            <main className="main" key={user.id}>
                                <div className="item">1</div>
                                <div className="item">
                                    <a onClick={() => goToUpdate(id)}>
                                        <span className="has-text-info">
                                            {id}
                                        </span>
                                    </a>
                                </div>
                                <div className="item">
                                    <span className="has-text-weight-bold">
                                        {username}
                                    </span>

                                </div>
                                <div className="item">{email}</div>
                                <div className="item">{name}</div>
                                <div className="item"><span>{createdAt}</span></div>
                                <div className="item">

                                    <a className="button  is-info is-inverted is-size-7 mt10"
                                       onClick={() => goToUpdate(id)}>
                                        <span className="icon is-small">
                                            <i className="fas fa-pen"/>
                                        </span>
                                        <span>EDIT</span>
                                    </a>
                                    <a className="button  is-danger is-inverted is-size-7 mt10"
                                       onClick={() => deleteUser(id)}>
                                        <span className="icon is-small">
                                            <i className="fas fa-trash"/>
                                        </span>
                                        <span>DELETE</span>
                                    </a>
                                </div>
                            </main>
                        )
                    })}
                </div>
                <Outlet/>
            </div>
        </div>
    )
}
